export default __webpack_public_path__ + "static/media/Experience_FlatGeneric_Vertical.90ea71ba.png";